<script>
  import TheReviewForm from '@/components/TheReviewForm'
  import LoadingScreen from '@/components/LoadingScreen'
  export default {
    name: 'ReviewPage',
    components: {
      TheReviewForm,
      LoadingScreen
    },
    created() {
      this.setupReview()
    },
    data() {
      return {
        opacity: 0.9,
        reviewId: this.$route.params.reviewId,
        ratingUrl: this.$route.params.ratingUrl
      }
    },
    computed: {
      loading() {
        return this.$store.state.common.ui.loading
      },
      reviewerRole() {
        let result = ''
        switch (this.$route.params.reviewerRole) {
          case 'ofdit':
            result = 'OFDIT reviewer'
            break
          case 'peer':
            result = 'Peer reviewer'
            break
          case 'dev':
            result = 'Developer'
            break
        }
        return result
      },
      reviewInfo() {
        return this.$store.getters.reviewInfo
      }
    },
    methods: {
      async setupReview() {
        try {
          // These are Grizzly users; grab token from store and then add to reviewInfo
          if (!this.ratingUrl) {
            const response = await this.$store.dispatch('cr_callAPI', {
              url: `/r/reviews/${this.reviewId}`,
              token: this.$store.state.courseDev.user.currentUser.token
            })
            response.user_token = this.$store.state.courseDev.user.currentUser.token
            await this.$store.commit('cr_updateReviewInfo', response)
            this.checkReviewOpen()
          } else if (this.ratingUrl) {
            // Reviewers and devs need to first get token, then get review, then add token to reviewInfo
            const tokenResponse = await this.$store.dispatch('cr_callAPI', {
              url: '/public',
              method: 'post',
              data: {
                reviewer_role: this.reviewerRole,
                rating_url: this.ratingUrl
              }
            })
            const token = tokenResponse.token
            const response = await this.$store.dispatch('cr_callAPI', {
              url: `/r/reviews/${this.reviewId}`,
              token: token
            })
            response.user_token = token
            await this.$store.commit('cr_updateReviewInfo', response)
            this.checkReviewOpen()
          }
        } catch (err) {
          // TODO: handle specific error statuses first, then go to a generic error
          if (!this.ratingURL) {
            this.$router.push('/login')
          } else {
            this.$router.push({
              name: 'error',
              params: {
                title: 'Review closed',
                message: `There was an issue accessing the review for ${this.reviewInfo.project_id}/${this.reviewInfo.course}. For additional assistance please contact us at the OFDIT admin email (see footer).`,
                errObj: err
              }
            })
          }
        } finally {
          this.$store.commit('updateLoadingStatus', false)
        }
      },
      checkReviewOpen() {
        if (
          this.reviewInfo.status === 'Closed' ||
          (this.reviewInfo.ofdit_reviewer_submit_date &&
            this.reviewInfo.reviewer_role === 'OFDIT reviewer') ||
          (this.reviewInfo.peer_reviewer_submit_date &&
            this.reviewInfo.reviewer_role === 'Peer reviewer')
        ) {
          this.$router.push({
            name: 'error',
            params: {
              title: 'Review closed',
              message: `The review form for ${this.reviewInfo.project_id}/${this.reviewInfo.course} is now closed. For additional assistance please contact us at the OFDIT admin email (see footer).`,
              errObj: {
                review_id: this.reviewInfo.id,
                status: this.reviewInfo.status,
                peer_reviewer_submit_date: this.reviewInfo
                  .peer_reviewer_submit_date,
                ofdit_reviewer_submit_date: this.reviewInfo
                  .ofdit_reviewer_submit_date
              }
            }
          })
        } else {
          this.$root.$bvToast.toast(
            `You have successfully authenticated to the review for ${this.reviewInfo.course}.`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
        }
      }
    }
  }
</script>

<template>
  <div>
    <div class="mt-5 pt-5" v-if="loading">
      <LoadingScreen></LoadingScreen>
    </div>
    <div v-else>
      <TheReviewForm></TheReviewForm>
    </div>
  </div>
</template>

<style></style>
